import _regeneratorRuntime from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import { getpubdnsdatadetail, getpubdnsdata } from "@/api/bizBillingdata";
import { formatTimeToStr } from "@/utils/date";
import QChart from "@/components/queryChart";
export default {
  name: "stat",
  components: {
    QChart: QChart
  },
  data: function data() {
    var _this = this;
    return {
      dateRange: [new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 1), new Date().getTime()],
      pickerOptions: {
        shortcuts: [{
          text: this.$t('dashborad.date-option.last-4h'),
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 4);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: this.$t('dashborad.date-option.last-24h'),
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: this.$t('dashborad.date-option.last-3d'),
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 3);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: this.$t('dashborad.date-option.last-1w'),
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: this.$t('dashborad.date-option.last-3w'),
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 21);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: this.$t('dashborad.date-option.last-1m'),
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }],
        onPick: function onPick(_ref) {
          var maxDate = _ref.maxDate,
            minDate = _ref.minDate;
          _this.choiceDate = minDate.getTime();
          if (maxDate) {
            _this.choiceDate = '';
          }
        },
        disabledDate: function disabledDate(time) {
          if (_this.choiceDate) {
            var one = 30 * 24 * 3600 * 1000;
            var minTime = _this.choiceDate - one;
            var maxTime = _this.choiceDate + one;
            return time.getTime() < minTime || time.getTime() > maxTime;
          }
        }
      },
      qData: {
        loading: true,
        total: 0,
        dataZoomShow: false
      },
      qTitle: this.$t('public-dns.stat.query-trend'),
      allrequest: 0,
      blockrequest: 0
    };
  },
  computed: {
    blockRate: function blockRate() {
      return (this.allrequest == 0 ? 0 : (this.blockrequest * 100 / this.allrequest).toFixed(2)) + '%';
    }
  },
  methods: {
    //添加refreshData方法进行自动设置数据
    getQueries: function getQueries() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _res$data;
        var params, resData, res, times, counts, counts1, total;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this2.qData = {
                loading: true
              };
              params = {
                authcode: _this2.$route.query.authCode,
                start: new Date(_this2.dateRange[0]).getTime() / 1000 | 0,
                end: new Date(_this2.dateRange[1]).getTime() / 1000 | 0
              };
              _context.next = 4;
              return getpubdnsdata(params);
            case 4:
              resData = _context.sent;
              if (resData && resData.data) {
                _this2.allrequest = resData.data.allrequest;
                _this2.blockrequest = resData.data.blockrequest;
              }
              _context.next = 8;
              return getpubdnsdatadetail(params);
            case 8:
              res = _context.sent;
              times = ["date"];
              counts = [_this2.$t('public-dns.stat.queries')];
              counts1 = [_this2.$t('public-dns.stat.blockes')];
              total = 0;
              (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.map(function (info) {
                times.push(formatTimeToStr(info.timestamp * 1000, 'MM-dd hh:mm'));
                counts.push(info.allrequest);
                counts1.push(info.blockrequest);
                total += info.count;
              });
              _this2.qData = {
                data: [times, counts, counts1],
                total: total,
                dataZoomShow: false
              };
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  },
  watch: {
    dateRange: function dateRange() {
      this.getQueries();
    }
  }
};